(function(){
    'use strict'

    angular.module('app.cantidades')
    .factory('CantidadesService', CantidadesService);

    CantidadesService.$inject = ['$http', '$q', 'apiSettings'];

    function CantidadesService($http, $q, apiSettings) {

        var api = {
            getAll: getAll,
            getAllDestajo: getAllDestajo,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/cantidades';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getAllDestajo(){

            var url = apiSettings.apiBaseUrl + 'api/cantidades/destajo';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(cantidadId){

            var url = apiSettings.apiBaseUrl + 'api/cantidades/' + cantidadId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(cantidad){

            cantidad.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/cantidades',  
                method: 'POST',  
                data: cantidad
            });  
            return response;
        };

        function update(cantidad){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/cantidades',  
                method: 'PUT',  
                data: cantidad
            });  
            return response;
        };

        function remove(cantidad){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/cantidades',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: cantidad
            });  
            return response;
        };

    };

})();        